import { Controller } from "@hotwired/stimulus"
import DragSelect from "dragselect"

// Connects to data-controller="tasks"
export default class extends Controller {
  connect() {
    // this.initializeDragSelect() // For now we don't need to drag select tasks but may be useful in the future
  }

  initializeDragSelect() {
    this.dragSelect = new DragSelect({
      selectables: document.querySelectorAll(".task-row"),
      area: document.querySelector(".tasks-list"),
      draggability: true,
    })
  }

}
